import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';

// import { MenuFlowPagesDirectiveSharedModule } from '@shared/core/directives/menuFlowPages/menu-flow-pages.directive.shared.module';
import { DisclaimerModule } from '@shared/core/components/disclaimer';

import { WizzardComponentsModule } from '../../components';

import { WizzardForProductComponent } from './wizzard-for-product.shared.component';

@NgModule({
    declarations: [
        WizzardForProductComponent
    ],
    imports: [
        CommonModule,
        WizzardComponentsModule,
        DisclaimerModule,
    ],
    exports: [
        WizzardForProductComponent
    ],
})
export class WizzardForProductModule { }
